import { z } from 'zod';

export enum EmailConfirmStatus {
  CONFIRMED = 'CONFIRMED',
  UNCONFIRMED = 'UNCONFIRMED',
}

export const EmailAddressSchema = z.object({
  emailId: z.number(),
  emailAddress: z.string(),
  confirmStatus: z.nativeEnum(EmailConfirmStatus),
  confirmSource: z.string().nullable(),
  confirmTime: z.string().nullable(),
  unconfirmTime: z.string().nullable(),
  confirmSourceType: z.string().nullable(),
  roles: z.array(z.string()),
  pendingRoles: z.array(z.string()),
  domainKeyInfo: z.unknown().nullable(),
  fromEmailAddress: z.string(),
});

export type EmailAddressResponse = z.infer<typeof EmailAddressSchema>;
